import { apiError } from '../../utils/errors';
import { getApiBaseUrl } from '../../utils/api-base-url';
import { ThirdPartyType } from '../../types';

export const postResendThirdPartyAccess = async (
  email: string,
  type: ThirdPartyType,
): Promise<void> => {
  const response = await fetch(`${getApiBaseUrl()}/access/third-party/resend`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      type,
    }),
  });

  const json = await response.json();

  if (!response.ok) {
    throw apiError(response.status, json?.message || 'Failed to resend code', json?.code);
  }
};
